import React from 'react'
import {
  CompanyProfileBuyerFormStyle,
  CompanyProfileModalFormStyle,
} from './styled'
// import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom'
import {
  Button,
  Checkbox,
  Image,
  Input,
  Section,
  SelectBox,
  InputTextarea,
  Table,
  Modal,
  Breadcrumbs,
} from '../../components'
import { ICONS } from '../../themes'
import {
  // ROUTE_PATH,
  // redirect,
  yup as Yup,
  STRING,
  toastActive,
  toastFail,
  trimmedString,
  localStorageService,
} from '../../helpers'
import { Formik, Form, FieldArray } from 'formik'
import { connect } from 'react-redux'
import {
  companyController,
  countryController,
  companyProfileController,
  purchasingSiteController,
  currencyExchangeRateController,
} from '../../apiService/index'
import { controller, pageCompanyProfileController } from '../../middleware'
import { dateMonDayYearTime } from '../../helpers/functions/format'
import { Editor } from 'react-draft-wysiwyg'

const TermsPreviewButton = ({ onPreview }) => (
  <div
    onClick={onPreview}
    style={{
      display: 'flex',
      alignItems: 'center',
      marginBottom: '6px',
      flexWrap: 'wrap',
    }}
  >
    <button
      type="button"
      style={{
        border: '1px solid #f1f1f1',
        backgroundColor: 'white',
        cursor: 'pointer',
      }}
    >
      Preview
    </button>
  </div>
)
import Numeral from 'numeral'
import NumberFormat from 'react-number-format'
import { EditorState, convertToRaw, ContentState, Modifier } from 'draft-js'
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './react-draft-wysiwyg.css'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
// import PropTypes from 'prop-types'

// class CustomOption extends React.Component {
//   constructor(props) {
//     super(props)
//     this.props = {
//       onChange: PropTypes.func,
//       editorState: PropTypes.object,
//     }
//   }

//   addStar = () => {
//     const { editorState, onChange } = this.props
//     const contentState = Modifier.replaceText(
//       editorState.getCurrentContent(),
//       editorState.getSelection(),
//       '⭐',
//       editorState.getCurrentInlineStyle()
//     )
//     onChange(EditorState.push(editorState, contentState, 'insert-characters'))
//   }

//   render() {
//     return <div onClick={this.addStar}>⭐</div>
//   }
// }

class CompanyProfileBuyerFormContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      optionsCountry: [],
      optionsCurrency: [],
      isEditPageState: true,
      templateValidText: STRING.INVALID,
      isSortBy: [
        { name: 'companyCode', value: undefined },
        { name: 'companyName', value: undefined },
      ],
      modals: [
        { name: 'editSite', isOpen: false },
        { name: 'addNew', isOpen: false },
        { name: 'delete', isOpen: false, fullName: '', idList: '' },
        { name: 'terms-conditions', isOpen: false },
        { name: 'addNewExchangeRate', isOpen: false },
        { name: 'editNewExchangeRate', isOpen: false },
      ],
      isDeletedName: '',
      isDeletedIndex: 0,
      purchasingEditIndex: 0,
      purchasingEditID: 0,
      purchasingEditCode: '',
      purchasingEditName: '',
      purchasingEditAddress: '',
      purchasingSiteInsert: [
        {
          name: '',
          address: '',
          company_code: '',
        },
      ],
      btnPurchasing: true,
      companyHistory: {
        id: null,
        company_name_eng: '',
        contact_address: '',
        create_by: null,
        create_date: null,
        email: '',
        fax: '',
        is_active: null,
        phone: '',
        regis_address: '',
        regis_country: '',
        supplier_portal: '',
        tax_id: '',
        update_by: null,
        update_date: null,
        website: '',
        base_currency: {
          id: 0,
          name: '',
        },
        term_condition: '',
        country: {
          id: 0,
          name: '',
          number_code: null,
          alpha2_code: null,
          alpha3_code: null,
          created_at: null,
          is_active: null,
          updated_at: null,
        },
      },
      companyForm: {
        id: null,
        company_en: '',
        contact_address: '',
        create_by: null,
        create_date: null,
        email: '',
        fax: '',
        is_active: null,
        phone: '',
        regis_address: '',
        regis_country: '',
        supplier_portal: '',
        tax_id: '',
        update_by: null,
        update_date: null,
        website: '',
        base_currency: {
          id: 0,
          name: '',
        },
        term_condition: '',
        contact_country: {
          id: 0,
          name: '',
          number_code: null,
          alpha2_code: null,
          alpha3_code: null,
          created_at: null,
          is_active: null,
          updated_at: null,
        },
      },
      purchasingSite: [],
      isLoading: false,
      checkRole: '',
      editorState: EditorState.createEmpty(),
      sort_by_purchasing: 'asc',
      sort_name_purchasing: 'code',

      sort_by_exchange: 'asc',
      sort_name_exchange: 'currency',
      exchangeRateInsert: [
        {
          country: '',
          currency: '',
          currency_id: '',
          currency_name: '',
          exchange_rate: '',
        },
      ],
      exchangeRateList: [],
      exchangeRateIndex: '',
      exchangeRateCountry: '',
      exchangeRateCurrency: '',
      exchangeRateEdit: '',
      exchangeRateID: '',
      exchange_rate_edit: '',
      can_delete: '',
      isErrSelectIndex: '',
      isErr: {},
      isErrExchangeRate: false,
      isErrCurrency: false,

      isDeletedExchangeId: '',
      isDeletedExchangeIndex: '',
      isDeletedExchangeName: '',
      editable: false,
      exchange_rate_type: '',
      isDeleteExchange: [],
    }
    this.renderDataCompany = this.renderDataCompany.bind(this)
    this.renderEditPurchasingSite = this.renderEditPurchasingSite.bind(this)
    this.renderAddPurchasingSite = this.renderAddPurchasingSite.bind(this)
  }

  componentDidMount() {
    this._isMounted = true
    this.getCompany()
    this.getCountry()
    this.getCurrency()
    this.getPurchasingSite()
    this.getExchangeRate()
    // this.getMaster.getCurrency()
    const roles = pageCompanyProfileController().asset()
    this.setState({ checkRole: roles })
  }
  getPurchasingSite = async (sort_by, sort_name) => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      const params = {
        sort_by: sort_by ? sort_by : this.state.sort_by_purchasing,
        sort_name: sort_name ? sort_name : this.state.sort_name_purchasing,
      }
      const res = await purchasingSiteController().getPurchasingSite(params)

      if (res) {
        if (this._isMounted) {
          this.setState({
            purchasingSite: res.map(val => {
              return val
            }),
          })
          this.setState({ isLoading: false })
        }
      }
    } catch (error) {
      throw error
    }
  }

  getCompany = async () => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      const res = await companyController().getCompany()
      if (res) {
        const html = res.term_condition
        const contentBlock = htmlToDraft(html)
        let editorState = EditorState.createEmpty()
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks
          )
          editorState = EditorState.createWithContent(contentState)
        }

        if (this._isMounted) {
          this.setState({
            companyForm: res,
            companyHistory: res,
            editorState: editorState,
          })
          this.setState({ isLoading: false })
        }
      }
    } catch (error) {
      throw error
    }
  }

  getCountry = async () => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      const res = await countryController().getListCountry()
      if (res) {
        const countryList = res.map(val => {
          return {
            value: val.id,
            label: val.name,
          }
        })
        if (this._isMounted) {
          this.setState({ optionsCountry: countryList })
          this.setState({ isLoading: false })
        }
      }
    } catch (error) {
      throw error
    }
  }

  getCurrency = async () => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      const res = await companyProfileController().getCurrency()
      if (res) {
        const currencyList = res.map(val => {
          return {
            value: val.id,
            label: val.name,
            country: val.country ? val.country.name : '',
          }
        })
        if (this._isMounted) {
          this.setState({ optionsCurrency: currencyList })
          this.setState({ isLoading: false })
        }
      }
    } catch (error) {
      throw error
    }
  }

  getExchangeRate = async sort_by => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      const res = await currencyExchangeRateController().getExchangeRate(
        sort_by ? sort_by : this.state.sort_by_exchange,
        this.state.sort_name_exchange
      )
      if (res) {
        // console.log('res getExchangeRate', res)
        const listExchange = res.company_currency.map((item, i) => {
          return {
            id: item.id,
            country: item.country.name,
            currency_id: item.currency.id,
            currency_name: item.currency.name,
            exchange_rate: item.exchange_rate,
            updated_at: item.updated_at,
            updated_by: item.updated_by,
            updated_by_id: item.updated_by_id,
            is_update: false,
            can_delete: item.can_delete,
          }
        })

        if (this._isMounted) {
          this.setState({
            exchangeRateList: listExchange,
            editable: res.editable,
            exchange_rate_type: res.exchange_rate_type,

            //Clear state Delete
            isDeleteExchange: [],
            isDeletedCurrencyId: '',
            isDeletedExchangeId: '',
            isDeletedExchangeIndex: '',
            isDeletedExchangeName: '',

            isLoading: false,
          })
        }
      }
    } catch (error) {
      throw error
    }
  }

  updateCompanyProfile = async () => {
    try {
      if (this._isMounted) {
        this.setState({ isLoading: true })
      }
      let exchangeRate = []
      let exchange = []
      if (
        this.state.exchangeRateList &&
        this.state.exchangeRateList.length > 0
      ) {
        this.state.exchangeRateList.map((item, i) => {
          exchange.push({
            id: item.id,
            currency_id: item.currency_id,
            exchange_rate: parseFloat(item.exchange_rate),
            updated_by: Number(item.updated_by_id),
            updated_at: item.updated_at,
            ...(item.is_update && { is_update: item.is_update }),
          })
        })
        if (
          this.state.isDeleteExchange &&
          this.state.isDeleteExchange.length > 0
        ) {
          exchangeRate = this.state.isDeleteExchange.concat(exchange)
        }
      }
      // console.log('exchangeRate', exchangeRate)
      // console.log('exchange', exchange)
      const req = {
        company: {
          phone: this.state.companyForm.phone,
          fax: this.state.companyForm.fax,
          email: this.state.companyForm.email,
          website: this.state.companyForm.website,
          supplier_portal: this.state.companyForm.supplier_portal,
          base_currency: parseInt(this.state.companyForm.base_currency.id, 10),
          term_condition: this.state.companyForm.term_condition,
          address: this.state.companyForm.address,
          contact_address: this.state.companyForm.contact_address,
          contact_country: parseInt(
            this.state.companyForm.contact_country.id,
            10
          ),
          editable: this.state.editable,
        },
        purchasing_company: this.state.purchasingSite,
        company_currency:
          this.state.isDeleteExchange.length > 0 ? exchangeRate : exchange,
      }

      const res = await companyProfileController().updateCompanyProfile(req)
      if (res) {
        if (res.status === 'UpdateSuccess') {
          toastActive('Update was successes')
          this.getCompany()
          this.getPurchasingSite()
          this.getExchangeRate()
        }
        // this.clearValid()
        // this.closeModal()
        // this.resetForm(formiksActions)
      } else {
        toastFail('Update was Fail')
      }
    } catch (error) {
      throw error
    }
  }

  backCompanyProfile = props => {
    // props.resetForm()
    setTimeout(() => {
      props.setSubmitting(false)
      props.resetForm()
    }, 0)
    props.setFieldValue(
      'supplier_portal',
      this.state.companyHistory.supplier_portal
    )

    props.setFieldValue('phone', this.state.companyHistory.phone)

    props.setFieldValue('email', this.state.companyHistory.email)

    props.setFieldValue(
      'contact_address',
      this.state.companyHistory.contact_address
    )
    props.setFieldValue('fax', this.state.companyHistory.fax)
    props.setFieldValue('website', this.state.companyHistory.website)
    props.setFieldValue('base_currency', {
      id: this.state.companyHistory.base_currency.id,
      name: this.state.companyHistory.base_currency.name,
    })
    props.setFieldValue(
      'term_condition',
      this.state.companyHistory.term_condition
    )
    props.setFieldValue('country', {
      id: this.state.companyHistory.contact_country.id,
      name: this.state.companyHistory.contact_country.name,
    })
    if (this._isMounted) {
      this.setState({
        companyForm: this.state.companyHistory,
        isEditPageState: true,
      })
    }
  }

  toggleSort = evt => {
    if (this._isMounted) {
      this.setState(prevState => ({
        ...prevState,
        isSortBy: prevState.isSortBy.map(column => ({
          ...column,
          value:
            column.name === evt
              ? column.value !== undefined
                ? column.value === 'asc'
                  ? 'desc'
                  : 'asc'
                : 'asc'
              : undefined,
        })),
      }))
    }
    if (
      this.state.isSortBy[0].value != undefined ||
      this.state.isSortBy[1].value != undefined
    ) {
      if (this.state.isSortBy[0].value != undefined) {
        if (this._isMounted) {
          this.setState({
            purchasingSite: this.state.purchasingSite.sort(
              this.compareValues('code', this.state.isSortBy[0].value)
            ),
          })
        }
      }
      if (this.state.isSortBy[1].value != undefined) {
        if (this._isMounted) {
          this.setState({
            purchasingSite: this.state.purchasingSite.sort(
              this.compareValues('name', this.state.isSortBy[1].value)
            ),
          })
        }
      }
    }
  }

  compareValues = (key, order = 'asc') => {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0
      }

      const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
      const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]

      let comparison = 0
      if (varA > varB) {
        comparison = 1
      } else if (varA < varB) {
        comparison = -1
      }
      return order === 'desc' ? comparison * -1 : comparison
    }
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  toggleModal = (evt, id, name) => {
    if (this._isMounted) {
      this.setState(prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
        })),
      }))
    }
  }

  validateSchema = () => {
    const schema = Yup.object().shape({
      name: Yup.string()
        .transform(nameValue => trimmedString(nameValue))
        .required(STRING.INVALID)
        .test('name', 'Company name duplicate', values => {
          return this.state.purchasingSite.find(
            (e, i) => i !== this.state.purchasingEditIndex && e.name === values
          )
            ? false
            : true
        }),
      address: Yup.string()
        .transform(addressAddress => trimmedString(addressAddress))
        .required(STRING.INVALID),
    })
    return schema
  }

  validateSchemaExchange = () => {
    const schema = Yup.object().shape({
      exchange_rate: Yup.string()
        .transform(exchange_rate => trimmedString(exchange_rate))
        .required(STRING.INVALID),
    })
    return schema
  }

  validateCompanyFormSchema = () => {
    const schema = Yup.object().shape({
      phone: Yup.string()
        .transform(phoneValue => trimmedString(phoneValue))
        .required(STRING.INVALID),
      email: Yup.string()
        .transform(emailValue => trimmedString(emailValue))
        .required(STRING.INVALID)
        .email(STRING.EMAIL_INVALID),

      contact_address: Yup.string()
        .transform(contactAddressValue => trimmedString(contactAddressValue))
        .required(STRING.INVALID),
    })
    return schema
  }

  validateSchemmPurchasing = () => {
    const schema = Yup.array().of(
      Yup.object()
        .shape({
          name: Yup.string()
            .transform(nameValue => trimmedString(nameValue))
            .required(STRING.INVALID)
            .test('name', 'Company name duplicate', values => {
              const purchasingSite = this.state.purchasingSite
              return purchasingSite.find(e => e.name === values) ? false : true
            }),
          address: Yup.string()
            .transform(addressAddress => trimmedString(addressAddress))
            .required(STRING.INVALID),
        })
        .uniqueProperty('name', 'Company name duplicate')
    )

    return schema
  }

  validateSchemmExchangeRate = () => {
    const schema = Yup.array().of(
      Yup.object().shape({
        // currency: Yup.string()
        //   .transform(currency => {
        //     console.log('currency', currency)
        //     trimmedString(currency.value)
        //   })
        //   .required(STRING.INVALID),
        exchange_rate: Yup.string()
          .transform(exchange_rate => trimmedString(exchange_rate))
          .required(STRING.INVALID),
      })
    )

    return schema
  }

  setInputArrayName = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`[${index}].name`, target.value)
  }

  setInputArrayAddress = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`[${index}].address`, target.value)
  }

  setInputArrayCompanyCode = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`[${index}].company_code`, target.value)
  }

  setInputArrayCountry = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`[${index}].country`, target.value)
  }

  setInputArrayExchangeRate = (formikSetvalue, event, index) => {
    const { target } = event
    formikSetvalue(`[${index}].exchange_rate`, target.value)
  }

  setInputArrayCurrency = (formikSetvalue, val, index) => {
    formikSetvalue(`[${index}].currency`, val)
    formikSetvalue(`[${index}].currency_id`, val.value)
    formikSetvalue(`[${index}].currency_name`, val.label)
    formikSetvalue(`[${index}].country`, val.country)
  }

  disabled = ele => {
    let chk = false
    ele.forEach(item => {
      if (item.name == '' || item.address == '') {
        chk = true
      }
    })
    return chk
  }

  isCheckCurrency = (currency_id, list) => {
    let chk = false
    list.map(item => {
      if (item.currency_id === currency_id) {
        chk = true
      }
    })
    return chk
  }

  checkDuplicateCurrency = (listInsert, listExchange, currency_id, i) => {
    let chk = false
    let isIndexLength = Number(listInsert.length - 1)
    if (this.isCheckCurrency(currency_id, listExchange)) {
      // เช็ค Array ใน Modal กับ table Exchange Rate
      chk = true
    } else if (i != isIndexLength) {
      // เช็ค Array ใน Modal เดียวกัน
      if (
        Number(currency_id) ===
        Number(listInsert[listInsert.length - 1].currency_id)
      ) {
        chk = true
      }
    }

    return chk
  }

  validateExchangeRate = (type, editExchange) => {
    let {
      exchangeRateInsert,
      exchangeRateList,
      isErr,
      isErrSelectIndex,
    } = this.state
    let check = true

    if (type === 'add') {
      exchangeRateInsert.forEach((item, i) => {
        if (
          item.exchange_rate === '' ||
          item.exchange_rate === undefined ||
          Number(item.exchange_rate) <= 0 ||
          Number(item.exchange_rate) === 0
        ) {
          check = false
          isErr[`exchangeRate_${i}`] = this.state.templateValidText
        }
        if (item.currency_id === '') {
          check = false
          isErr[`currency_${i}`] = this.state.templateValidText
        }
        if (
          this.checkDuplicateCurrency(
            exchangeRateInsert,
            exchangeRateList,
            item.currency_id,
            i
          )
        ) {
          check = false
          isErr[`currency_${isErrSelectIndex}`] = 'This currency selected'
        }
      })
    } else {
      if (
        editExchange === '' ||
        editExchange === undefined ||
        Number(editExchange) <= 0 ||
        Number(editExchange) === 0
      ) {
        check = false
        isErr[`exchangeRate_edit`] = this.state.templateValidText
      }
    }
    this.setState({ isErr })
    return check
  }

  submitAddExchangeRate = () => {
    let { exchangeRateInsert, exchangeRateList } = this.state
    let date = new Date()

    if (exchangeRateInsert && exchangeRateInsert.length > 0) {
      const resUserName = localStorageService.getUsersName()
      const resUserBuyerId = localStorageService.getBuyerId()
      const insert_exchange = exchangeRateInsert.map((item, i) => {
        return {
          country: item.country,
          currency_id: item.currency.value,
          currency_name: item.currency.label,
          exchange_rate: item.exchange_rate,
          id: item.id,
          created_at: date.toJSON(),
          updated_at: date.toJSON(),
          created_by: resUserName,
          updated_by: resUserName,
          updated_by_id: resUserBuyerId,
          is_update: false,
          can_delete: true,
        }
      })

      let arrayAdd = exchangeRateList.concat(insert_exchange)

      if (this._isMounted) {
        this.setState({
          exchangeRateList: arrayAdd,
          exchangeRateInsert: [
            {
              country: '',
              currency: '',
              currency_id: '',
              currency_name: '',
              exchange_rate: '',
            },
          ],
        })
      }
      this.toggleModal('addNewExchangeRate')
      document.body.classList.remove('modal-open')
    }
  }

  onEditorStateChange = editorState => {
    this.setState({
      editorState,
      companyForm: {
        ...this.state.companyForm,
        term_condition: draftToHtml(
          convertToRaw(editorState.getCurrentContent())
        ),
        // value: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      },
    })
  }

  onChange = e => {
    this.setState({ value: e.target.value })
  }

  renderDataCompany = (isEditPageState, optionsCountry, optionsCurrency) => {
    const { editorState } = this.state

    const value = this.state
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.state.companyForm}
        validationSchema={this.validateCompanyFormSchema}
        validateOnChange={true}
        onSubmit={(values, actions) => {
          if (this._isMounted) {
            this.setState({
              companyForm: values,
              companyHistory: values,
              isEditPageState: true,
            })
          }
        }}
      >
        {props => {
          return (
            <Form>
              <Section className="main-content">
                <Section className="content-body">
                  <Section className="form-wrapper">
                    <Section className="form-group-title">Details</Section>

                    <Section className="form-group">
                      <label>Company Name</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            value={this.state.companyForm.company_name_eng}
                            disabled={true}
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label>Tax ID</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={this.state.companyForm.tax_id}
                          />
                        </Section>

                        <Section className="message">error</Section>
                      </Section>
                    </Section>

                    <Section className="form-row">
                      <Section className="form-col col-6">
                        <Section className="form-group-header">
                          Registered Address
                        </Section>

                        <Section className="form-group">
                          <label>Address</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <InputTextarea
                                disabled={true}
                                value={this.state.companyForm.regis_address}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>

                        <Section className="form-group">
                          <label>Country</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                disabled={true}
                                value={this.state.companyForm.regis_country}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>
                      </Section>

                      <Section className="form-col col-6">
                        <Section className="form-group-header grid-to-label">
                          Contact Address
                        </Section>

                        <Section
                          className={`form-group ${
                            props.errors.contact_address && 'is-error'
                          }`}
                        >
                          <label>Address</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <InputTextarea
                                name="contact_address"
                                disabled={isEditPageState}
                                value={props.values.contact_address}
                                onChange={props.handleChange('contact_address')}
                                onBlur={props.handleBlur('contact_address')}
                              ></InputTextarea>
                            </Section>

                            <Section className="message">
                              {props.errors.contact_address &&
                                this.state.templateValidText}
                            </Section>
                          </Section>
                        </Section>
                        <Section className="form-group">
                          <label>Country</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <SelectBox
                                id="active_status_filter"
                                name="country"
                                value={{
                                  value: props.values.contact_country.id,
                                  label: props.values.contact_country.name,
                                }}
                                options={optionsCountry}
                                isSearchable={false}
                                onChange={val => {
                                  props.setFieldValue('country', {
                                    id: val.value,
                                    name: val.label,
                                  })
                                }}
                                // isClearable={true}
                                isDisabled={isEditPageState}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>
                      </Section>
                    </Section>

                    <Section
                      className={`form-group ${
                        props.errors.phone && 'is-error'
                      }`}
                    >
                      <label>Phone</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            name="phone"
                            type="text"
                            value={props.values.phone}
                            onChange={props.handleChange('phone')}
                            onBlur={props.handleBlur('phone')}
                            disabled={isEditPageState}
                          />
                        </Section>

                        <Section className="message">
                          {props.errors.phone && props.errors.phone}
                        </Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label>
                        Fax <br /> (Optional)
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            value={props.values.fax}
                            onChange={props.handleChange('fax')}
                            disabled={isEditPageState}
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    <Section
                      className={`form-group ${
                        props.errors.email && 'is-error'
                      }`}
                    >
                      <label>Email</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            name="email"
                            type="text"
                            value={props.values.email}
                            onChange={props.handleChange('email')}
                            onBlur={props.handleBlur('email')}
                            disabled={isEditPageState}
                          />
                        </Section>

                        <Section className="message">
                          {props.errors.email}
                        </Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label>
                        Website <br /> (Optional)
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            value={props.values.website}
                            onChange={props.handleChange('website')}
                            disabled={isEditPageState}
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    <Section
                      className={`form-group ${
                        props.errors.supplier_portal && 'is-error'
                      }`}
                    >
                      <label>
                        Supplier Portal <br /> (Optional)
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            name="supplier_portal"
                            value={props.values.supplier_portal}
                            onChange={props.handleChange('supplier_portal')}
                            onBlur={props.handleBlur('supplier_portal')}
                            disabled={isEditPageState}
                          />
                        </Section>

                        <Section className="message">
                          {props.errors.supplier_portal &&
                            this.state.templateValidText}
                        </Section>
                      </Section>
                    </Section>
                    <Section className="form-group">
                      <label>Base Currency</label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          {/* <Input
                            type="text"
                            value={props.values.base_currency}
                            onChange={props.handleChange('base_currency')}
                            disabled={true}
                          /> */}
                          <SelectBox
                            id="active_status_filter"
                            name="base_currency"
                            value={{
                              value: props.values.base_currency.id,
                              label: props.values.base_currency.name,
                            }}
                            options={optionsCurrency}
                            isSearchable={false}
                            onChange={val => {
                              props.setFieldValue('base_currency', {
                                id: val.value,
                                name: val.label,
                              })
                            }}
                            isClearable={true}
                            isDisabled={true}
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    {/* <Section className="form-group">
                      <label>Exchange Rate</label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Switcher
                          onChange={() => this.togleSwitchActive(isActive)}
                          checked={isActive}
                          />
                        </Section>
                        <Section className="message"></Section>
                      </Section>
                    </Section> */}

                    <Section className="form-group">
                      <label>Term & Condition</label>
                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Editor
                            editorState={editorState}
                            wrapperClassName="wrapper-class"
                            editorClassName="editor-class"
                            toolbarClassName="toolbar-class"
                            toolbarCustomButtons={[
                              <TermsPreviewButton
                                key="preview"
                                onPreview={() => {
                                  this.toggleModal('terms-conditions')
                                  document.body.classList.add('modal-open')
                                }}
                              />,
                            ]}
                            editorStyle={
                              isEditPageState
                                ? {
                                    paddingLeft: '5px',
                                    minHeight: '200px',
                                    maxHeight: '500px',
                                    backgroundColor: '#dddddd',
                                    color: '#848484',
                                  }
                                : {
                                    paddingLeft: '5px',
                                    minHeight: '200px',
                                    maxHeight: '500px',
                                  }
                            }
                            toolbarStyle={{
                              fontSize: '12px',
                            }}
                            wrapperStyle={{
                              border: '1px solid #f1f1f1',
                            }}
                            readOnly={isEditPageState}
                            onEditorStateChange={this.onEditorStateChange}
                          />

                          {/* <Editor
                            editorState={editorState}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={this.onEditorStateChange}
                          /> */}
                        </Section>
                        {/* <div>
                          <textarea
                            disabled
                            value={draftToHtml(
                              convertToRaw(editorState.getCurrentContent())
                            )}
                          />
                        </div> */}
                        {/* <Section>
                          <InputTextarea
                            name="term_condition"
                            value={props.values.term_condition}
                            onChange={props.handleChange('term_condition')}
                            disabled={isEditPageState}
                          />
                        </Section> */}

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    {this.state.isEditPageState ? (
                      <Section className="form-actions">
                        {this.state.checkRole && (
                          <Button
                            onClick={() => {
                              if (this._isMounted) {
                                return this.setState({ isEditPageState: false })
                              }
                            }}
                            className="theme-blue"
                          >
                            Edit
                          </Button>
                        )}
                      </Section>
                    ) : (
                      <Section className="form-actions">
                        {this.state.checkRole && (
                          <Button
                            onClick={() => {
                              this.backCompanyProfile(props)
                              if (this._isMounted) {
                                this.setState({})
                              }
                            }}
                            className="theme-border-gray"
                          >
                            Cancel
                          </Button>
                        )}
                        {this.state.checkRole && (
                          <Button
                            onClick={props.submitForm}
                            className="theme-green"
                          >
                            Ok
                          </Button>
                        )}
                      </Section>
                    )}
                  </Section>

                  <Section className="form-wrapper purchasing">
                    <Section className="form-group-title">
                      Purchasing Site
                    </Section>
                    <Section className="form-actions form-actions-add">
                      {this.state.checkRole && (
                        <Button
                          className="theme-blue add"
                          onClick={() => {
                            this.toggleModal('addNew')
                            document.body.classList.add('modal-open')
                          }}
                        >
                          Add New
                        </Button>
                      )}
                    </Section>
                    <Section className="table-responsive">
                      <Table className="table-fixed table-default table-purchasing is-scrollbar">
                        <Table.THEAD>
                          <Table.TR>
                            <Table.TH
                              isSortable={true}
                              // sortBy={this.filterSortByValue('companyCode')}
                              // onClick={() => this.toggleSort('companyCode')}
                              sortBy={
                                this.state.sort_name_purchasing === 'code' &&
                                this.state.sort_by_purchasing
                              }
                              onClick={() => {
                                if (this.state.sort_by_purchasing === 'asc') {
                                  this.setState({
                                    sort_by_purchasing: 'desc',
                                    sort_name_purchasing: 'code',
                                  })
                                  this.getPurchasingSite('desc', 'code')
                                } else {
                                  this.setState({
                                    sort_by_purchasing: 'asc',
                                    sort_name_purchasing: 'code',
                                  })
                                  this.getPurchasingSite('asc', 'code')
                                }
                              }}
                            >
                              COMPANY CODE
                            </Table.TH>

                            <Table.TH
                              isSortable={true}
                              // sortBy={this.filterSortByValue('companyName')}
                              // onClick={() => this.toggleSort('companyName')}
                              sortBy={
                                this.state.sort_name_purchasing === 'name' &&
                                this.state.sort_by_purchasing
                              }
                              onClick={() => {
                                if (this.state.sort_by_purchasing === 'asc') {
                                  this.setState({
                                    sort_by_purchasing: 'desc',
                                    sort_name_purchasing: 'name',
                                  })
                                  this.getPurchasingSite('desc', 'name')
                                } else {
                                  this.setState({
                                    sort_by_purchasing: 'asc',
                                    sort_name_purchasing: 'name',
                                  })
                                  this.getPurchasingSite('asc', 'name')
                                }
                              }}
                            >
                              COMPANY NAME
                            </Table.TH>

                            <Table.TH>ADDRESS</Table.TH>

                            <Table.TH className="actions w-200 w-none text-center">
                              ACTIONS
                            </Table.TH>
                          </Table.TR>
                        </Table.THEAD>
                        <Table.TBODY>
                          {this.state.purchasingSite.map((item, index) => (
                            <Table.TR key={index}>
                              <Table.TD>{item.code}</Table.TD>

                              <Table.TD>{item.name}</Table.TD>

                              <Table.TD>{item.address}</Table.TD>

                              <Table.TD className="actions w-200 w-none text-center">
                                <>
                                  {this.state.checkRole && (
                                    <Button
                                      className="link"
                                      onClick={() => {
                                        if (this._isMounted) {
                                          this.setState(
                                            {
                                              purchasingEditIndex: index,
                                              purchasingEditID: item.id,
                                              purchasingEditCode: item.code,
                                              purchasingEditName: item.name,
                                              purchasingEditAddress:
                                                item.address,
                                            },
                                            this.toggleModal('editSite')
                                          )
                                        }
                                        return document.body.classList.add(
                                          'modal-open'
                                        )
                                      }}
                                    >
                                      <Image
                                        className="edit-icon"
                                        src={ICONS['icon-edit.svg']}
                                        alt="Edit"
                                        tootipValue={`Edit`}
                                        useTootipFor="Edit"
                                        useTootip={true}
                                      />
                                    </Button>
                                  )}
                                  {this.state.checkRole && (
                                    <Button
                                      className="link"
                                      onClick={() => {
                                        if (this._isMounted) {
                                          this.setState({
                                            isDeletedName: item.name,
                                            isDeletedIndex: index,
                                          })
                                        }
                                        this.toggleModal('delete')
                                        return document.body.classList.add(
                                          'modal-open'
                                        )
                                      }}
                                    >
                                      <Image
                                        className="delete-icon"
                                        src={ICONS['icon-trash.svg']}
                                        alt="Delete"
                                        tootipValue={`Delete`}
                                        useTootipFor="Delete"
                                        useTootip={true}
                                      />
                                    </Button>
                                  )}
                                </>
                              </Table.TD>
                            </Table.TR>
                          ))}
                        </Table.TBODY>
                      </Table>
                    </Section>
                  </Section>
                  <Section className="form-wrapper exchange">
                    <Section className="form-group-title">
                      Exchange Rate
                    </Section>

                    <Section className="row" mb="1rem">
                      <Section className="form-group">
                        <label className="label">Editable</label>
                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Checkbox
                              id="no"
                              value="1"
                              type="radio"
                              name="statusDraw"
                              checked={!this.state.editable}
                              className="inline"
                              onChange={e => {
                                this.setState({ editable: false })
                              }}
                            >
                              No
                            </Checkbox>
                            <Checkbox
                              id="yes"
                              value="2"
                              type="radio"
                              name="statusDraw"
                              checked={this.state.editable}
                              className="inline"
                              onChange={e => {
                                this.setState({ editable: true })
                              }}
                            >
                              Yes
                            </Checkbox>
                          </Section>
                        </Section>
                      </Section>
                    </Section>
                    <Section className="row" mb="1rem">
                      <Section className="form-group">
                        <label className="label">Exchange Rate</label>
                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Input
                              name="exchange_rate_type"
                              type="text"
                              value={props.values.exchange_rate_type}
                              disabled={true}
                            />
                          </Section>
                        </Section>
                        {/* <label className="label">
                          {this.state.exchange_rate_type}
                        </label> */}
                      </Section>
                    </Section>

                    <Section
                      className="form-actions form-actions-add"
                      mb="1rem"
                    >
                      {this.state.exchange_rate_type.includes('Fixed')
                        ? this.state.checkRole && (
                            <Button
                              className="theme-blue add"
                              onClick={async () => {
                                this.toggleModal('addNewExchangeRate')
                                document.body.classList.add('modal-open')
                              }}
                            >
                              Add New
                            </Button>
                          )
                        : this.state.exchange_rate_type.includes('Auto') && (
                            <label className="label">
                              (Daily update from BOT)
                            </label>
                          )}
                    </Section>
                    <Section className="table-responsive">
                      <Table className="table-fixed table-default table-exchange-rate is-scrollbar">
                        <Table.THEAD>
                          <Table.TR>
                            <Table.TH className="text-center">COUNTRY</Table.TH>
                            <Table.TH
                              className="text-center"
                              isSortable={true}
                              sortBy={this.state.sort_by_exchange}
                              onClick={() => {
                                if (this.state.sort_by_exchange === 'asc') {
                                  this.setState({ sort_by_exchange: 'desc' })
                                  this.getExchangeRate('desc')
                                } else {
                                  this.setState({ sort_by_exchange: 'asc' })
                                  this.getExchangeRate('asc')
                                }
                              }}
                            >
                              CURRENCY
                            </Table.TH>
                            <Table.TH className="text-right">
                              EXCHANGE RATE
                            </Table.TH>

                            <Table.TH className="update text-center">
                              LAST UPDATE
                            </Table.TH>

                            <Table.TH className="text-center">
                              UPDATE BY
                            </Table.TH>

                            {this.state.exchange_rate_type.includes('Auto') ? (
                              ''
                            ) : (
                              <Table.TH className="actions w-200 text-center">
                                ACTIONS
                              </Table.TH>
                            )}
                          </Table.TR>
                        </Table.THEAD>
                        <Table.TBODY>
                          {this.state.exchangeRateList.map((item, index) => {
                            return (
                              <Table.TR key={index}>
                                <Table.TD className="text-center">
                                  {item.country || '-'}
                                </Table.TD>
                                <Table.TD className="text-center">
                                  {item.currency_name || '-'}
                                </Table.TD>
                                <Table.TD className="text-right">
                                  {Numeral(item.exchange_rate).format(
                                    '0,0.0000'
                                  ) || '-'}
                                </Table.TD>
                                <Table.TD className="update text-center">
                                  {dateMonDayYearTime(item.updated_at)}
                                </Table.TD>
                                <Table.TD className="text-center">
                                  {item.updated_by || '-'}
                                </Table.TD>

                                {this.state.exchange_rate_type.includes(
                                  'Auto'
                                ) ? (
                                  ''
                                ) : (
                                  <Table.TD className="actions w-200">
                                    <Section className="text-center">
                                      {this.state.checkRole && (
                                        <Button
                                          className="link"
                                          onClick={() => {
                                            if (this._isMounted) {
                                              this.setState(
                                                {
                                                  exchangeRateIndex: index,
                                                  exchangeRateID: item.id,
                                                  exchangeRateCurrency: {
                                                    value: item.currency_id,
                                                    label: item.currency_name,
                                                  },
                                                  exchangeRateCountry:
                                                    item.country,
                                                  exchangeRateEdit:
                                                    item.exchange_rate,
                                                  can_delete: item.can_delete,
                                                },
                                                this.toggleModal(
                                                  'editNewExchangeRate'
                                                )
                                              )
                                            }
                                            return document.body.classList.add(
                                              'modal-open'
                                            )
                                          }}
                                        >
                                          <Image
                                            className="edit-icon"
                                            src={ICONS['icon-edit.svg']}
                                            alt="Edit"
                                            tootipValue={`Edit`}
                                            useTootipFor="Edit"
                                            useTootip={true}
                                          />
                                        </Button>
                                      )}
                                      {item.can_delete && this.state.checkRole && (
                                        <Button
                                          className="link"
                                          onClick={() => {
                                            if (this._isMounted) {
                                              this.setState({
                                                isDeletedCurrencyId:
                                                  item.currency_id,
                                                isDeletedExchangeId: item.id,
                                                isDeletedExchangeName: `${item.country} - ${item.currency_name}`,
                                                isDeletedExchangeIndex: index,
                                              })
                                            }
                                            this.toggleModal('delete')
                                            return document.body.classList.add(
                                              'modal-open'
                                            )
                                          }}
                                        >
                                          <Image
                                            className="delete-icon"
                                            src={ICONS['icon-trash.svg']}
                                            alt="Delete"
                                            tootipValue={`Delete`}
                                            useTootipFor="Delete"
                                            useTootip={true}
                                          />
                                        </Button>
                                      )}
                                    </Section>
                                  </Table.TD>
                                )}
                              </Table.TR>
                            )
                          })}
                        </Table.TBODY>
                      </Table>
                    </Section>

                    <Section className="form-actions" mt="1rem">
                      {this.state.checkRole && (
                        <Button
                          disabled={!isEditPageState}
                          onClick={() => {
                            isEditPageState && this.updateCompanyProfile()
                          }}
                          className="theme-green"
                        >
                          Save
                        </Button>
                      )}
                    </Section>
                  </Section>
                </Section>
              </Section>
            </Form>
          )
        }}
      </Formik>
    )
  }
  renderEditPurchasingSite = () => {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          id: this.state.purchasingEditID,
          name: this.state.purchasingEditName,
          code: this.state.purchasingEditCode,
          address: this.state.purchasingEditAddress,
        }}
        validationSchema={this.validateSchema}
        validateOnChange={true}
        onSubmit={values => {
          let { purchasingSite } = this.state
          purchasingSite[this.state.purchasingEditIndex] = {
            id: values.id,
            name: values.name,
            code: values.code,
            address: values.address,
          }
          if (this._isMounted) {
            this.setState({
              purchasingSite,
            })
          }
          this.toggleModal('editSite')
        }}
      >
        {props => {
          return (
            <Form>
              <Modal.Header>Edit Purchasing Site</Modal.Header>
              <Modal.Body>
                <Section className="table-responsive">
                  <Table className="table-fixed">
                    <Table.THEAD>
                      <Table.TR>
                        <Table.TH>COMPANY CODE</Table.TH>

                        <Table.TH>COMPANY NAME</Table.TH>

                        <Table.TH>ADDRESS</Table.TH>
                      </Table.TR>
                    </Table.THEAD>
                    <Table.TBODY>
                      <Table.TR>
                        <Table.TD>
                          <Input
                            value={props.values.code}
                            onChange={props.handleChange('code')}
                          />
                        </Table.TD>
                        <Table.TD isError={props.errors.name}>
                          <Input
                            type="text"
                            name="name"
                            value={props.values.name}
                            onChange={props.handleChange('name')}
                            onBlur={props.handleBlur('name')}
                          />
                          {props.errors.name && (
                            <Section className="message">
                              {props.errors.name}
                            </Section>
                          )}
                        </Table.TD>
                        <Table.TD isError={props.errors.address}>
                          <Input
                            type="text"
                            name="address"
                            value={props.values.address}
                            onChange={props.handleChange('address')}
                            onBlur={props.handleBlur('address')}
                          />
                          {props.errors.address && (
                            <Section className="message">
                              {this.state.templateValidText}
                            </Section>
                          )}
                        </Table.TD>
                      </Table.TR>
                    </Table.TBODY>
                  </Table>
                  {/* <Table className="company-name split-row-color data-table">
                    <Table.TBODY>
                      <Table.TR>
                        <Table.TD className="code">
                          <Input
                            value={props.values.code}
                            onChange={props.handleChange('code')}
                          />
                        </Table.TD>
                        <Table.TD
                          className={`company ${
                            props.errors.name && 'is-error'
                          }`}
                        >
                          <Input
                            type="text"
                            name="name"
                            value={props.values.name}
                            onChange={props.handleChange('name')}
                            onBlur={props.handleBlur('name')}
                          />
                          <Section className="message">
                            {props.errors.name &&
                              this.state.templateValidText}
                            {props.errors.name}
                          </Section>
                        </Table.TD>
                        <Table.TD
                          className={`company ${
                            props.errors.address && 'is-error'
                          }`}
                        >
                          <Input
                            type="text"
                            name="address"
                            value={props.values.address}
                            onChange={props.handleChange('address')}
                            onBlur={props.handleBlur('address')}
                          />
                          <Section className="message">
                            {props.errors.address &&
                              this.state.templateValidText}
                          </Section>
                        </Table.TD>
                      </Table.TR>
                    </Table.TBODY>
                  </Table> */}
                </Section>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  className="theme-border-gray close"
                  onClick={() => {
                    if (this._isMounted) {
                      this.setState(
                        {
                          purchasingEditIndex: 0,
                          purchasingEditID: 0,
                          purchasingEditCode: '',
                          purchasingEditName: '',
                          purchasingEditAddress: '',
                        },
                        this.toggleModal('editSite')
                      )
                    }
                    return document.body.classList.remove('modal-open')
                  }}
                >
                  Close
                </Button>

                <Button
                  className="theme-green save"
                  onClick={() => {
                    props.submitForm()
                    document.body.classList.remove('modal-open')
                  }}
                >
                  Ok
                </Button>
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    )
  }
  renderAddPurchasingSite = () => {
    return (
      <Formik
        enableReinitialize
        initialValues={this.state.purchasingSiteInsert}
        validationSchema={this.validateSchemmPurchasing}
        validateOnChange={true}
        validateOnBlur={false}
        onSubmit={(values, formiksAction) => {
          let date = new Date()
          const res = values.map((val, index) => {
            return {
              // id: 0, // Hide for used insert process
              name: val.name,
              code: val.company_code.trim(),
              address: val.address,
              company_id: 0,
              created_at: date.toJSON(),
              created_by: 0,
              is_deleted: false,
              updated_at: date.toJSON(),
              updated_by: 0,
            }
          })
          if (this._isMounted) {
            this.setState({
              purchasingSite: [...this.state.purchasingSite, ...res],
            })
          }
          formiksAction.resetForm()
          this.toggleModal('addNew')
          document.body.classList.remove('modal-open')
        }}
      >
        {formikProps => {
          const {
            values,
            handleChange,
            errors,
            submitForm,
            setFieldValue,
          } = formikProps

          let chk = false

          values.forEach(item => {
            if (item.name == '' || item.address == '') {
              chk = true
            }
          })

          return (
            <Form>
              <Modal.Header>Add Purchasing Site</Modal.Header>
              <Modal.Body>
                {values.length > 0 && (
                  <FieldArray
                    name="purchasing"
                    render={helper => {
                      return (
                        <>
                          <Section className="table-responsive">
                            <Table className="table-fixed is-scrollbar">
                              <Table.THEAD>
                                <Table.TR>
                                  <Table.TH>COMPANY CODE</Table.TH>

                                  <Table.TH>COMPANY NAME</Table.TH>

                                  <Table.TH>ADDRESS</Table.TH>

                                  <Table.TH className="actions w-none text-center">
                                    ACTION
                                  </Table.TH>
                                </Table.TR>
                              </Table.THEAD>
                              <Table.TBODY>
                                {values.map((item, index) => {
                                  return (
                                    <Table.TR key={index}>
                                      <Table.TD>
                                        <Input
                                          name="company_code"
                                          onChange={event =>
                                            this.setInputArrayCompanyCode(
                                              setFieldValue,
                                              event,
                                              index
                                            )
                                          }
                                          value={item.company_code}
                                        />
                                      </Table.TD>
                                      <Table.TD
                                        className={`${
                                          errors[index] != undefined &&
                                          errors[index].name &&
                                          'is-error'
                                        }  `}
                                      >
                                        <Input
                                          type="text"
                                          // name={`name[${index}]`}
                                          name={`name[${index}]`}
                                          value={item.name}
                                          onChange={event => {
                                            this.setInputArrayName(
                                              setFieldValue,
                                              event,
                                              index
                                            )
                                          }}
                                        />
                                        {errors[index] != undefined &&
                                          errors[index].name && (
                                            <Section className="message">
                                              {errors[index].name}
                                            </Section>
                                          )}
                                      </Table.TD>
                                      <Table.TD
                                        className={
                                          errors[index] != undefined &&
                                          errors[index].address
                                            ? 'is-error address'
                                            : 'address'
                                        }
                                      >
                                        <Input
                                          type="text"
                                          name={`address[${index}]`}
                                          value={item.address}
                                          onChange={event => {
                                            this.setInputArrayAddress(
                                              setFieldValue,
                                              event,
                                              index
                                            )
                                          }}
                                        />
                                        {errors[index] != undefined &&
                                          errors[index].address && (
                                            <Section className="message">
                                              {errors[index].address}
                                            </Section>
                                          )}
                                        {/* <Section className="message">
                                          {errors[index] != undefined &&
                                            errors[index].address &&
                                            errors[index].address}
                                        </Section> */}
                                      </Table.TD>
                                      <Table.TD className="actions w-none text-center">
                                        {values.length != 1 && (
                                          <Button
                                            className="icon"
                                            onClick={() => {
                                              values.splice(index, 1)
                                              if (this._isMounted) {
                                                return this.setState({})
                                              }
                                            }}
                                          >
                                            <Image
                                              className="delete-icon"
                                              src={ICONS['icon-trash.svg']}
                                              alt="delete"
                                            />
                                          </Button>
                                        )}
                                      </Table.TD>
                                    </Table.TR>
                                  )
                                })}
                              </Table.TBODY>
                            </Table>
                          </Section>
                          <Section className="form-actions-center">
                            <Button
                              className="theme-blue"
                              disabled={this.disabled(values)}
                              onClick={() => {
                                if (!chk) {
                                  helper.form.values.push({
                                    name: '',
                                    address: '',
                                    company_code: '',
                                  })
                                  if (this._isMounted) {
                                    return this.setState({})
                                  }
                                }
                              }}
                            >
                              Add more
                            </Button>
                          </Section>
                        </>
                      )
                    }}
                  ></FieldArray>
                )}
              </Modal.Body>

              <Modal.Footer>
                <Button
                  className="theme-border-gray close"
                  onClick={() => {
                    formikProps.resetForm(), this.toggleModal('addNew')
                    document.body.classList.remove('modal-open')
                  }}
                >
                  Cancel
                </Button>

                <Button
                  className="theme-green save"
                  onClick={() => submitForm()}
                >
                  Ok
                </Button>
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    )
  }

  renderEditExchangeRate = () => {
    const { isErr, exchangeRateEdit } = this.state
    let date = new Date()
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          id: this.state.exchangeRateID,
          currency: this.state.exchangeRateCurrency,
          country: this.state.exchangeRateCountry,
          exchange_rate: this.state.exchangeRateEdit,
          can_delete: this.state.can_delete,
        }}
        // validationSchema={this.validateSchemaExchange}
        validateOnChange={false}
        onSubmit={values => {
          let { exchangeRateList } = this.state
          const resUserName = localStorageService.getUsersName()
          const resUserBuyerId = localStorageService.getBuyerId()
          exchangeRateList[this.state.exchangeRateIndex] = {
            country: values.country,
            currency_id: values.currency.value,
            currency_name: values.currency.label,
            exchange_rate: this.state.exchangeRateEdit,
            id: values.id,
            updated_at: date.toJSON(),
            updated_by: resUserName,
            updated_by_id: resUserBuyerId,
            is_update: values.id ? true : false,
            can_delete: values.can_delete,
          }
          if (this._isMounted) {
            this.setState({
              exchangeRateList,
            })
          }
          this.toggleModal('editNewExchangeRate')
        }}
      >
        {props => {
          return (
            <Form>
              <Modal.Header>Edit Exchange Rate</Modal.Header>
              <Modal.Body>
                <Section className="table-responsive">
                  <Table className="table-fixed">
                    <Table.THEAD>
                      <Table.TR>
                        <Table.TH className="text-center">Country</Table.TH>

                        <Table.TH className="text-center">Currency</Table.TH>

                        <Table.TH className="text-center">
                          Exchange Rate
                        </Table.TH>
                      </Table.TR>
                    </Table.THEAD>
                    <Table.TBODY>
                      <Table.TR>
                        <Table.TD>
                          <Input
                            name="country"
                            value={props.values.country}
                            disabled={true}
                          />
                        </Table.TD>
                        <Table.TD>
                          <Input
                            name="country"
                            value={props.values.currency.label}
                            disabled={true}
                          />
                        </Table.TD>
                        <Table.TD
                          isError={isErr[`exchangeRate_edit`]}
                          className="exchange-rate text-right"
                        >
                          <NumberFormat
                            name="exchange_rate"
                            value={this.state.exchangeRateEdit}
                            customInput={Input}
                            decimalScale={4}
                            placeholder="0.0000"
                            isAllowed={inputObj => {
                              const { value } = inputObj
                              if (value !== '-') return true
                              return false
                            }}
                            onValueChange={e => {
                              isErr[`exchangeRate_edit`] = ''
                              if (e.floatValue <= 0) {
                                this.setState({
                                  isErr,
                                  exchangeRateEdit: null,
                                })
                              } else {
                                this.setState({
                                  isErr,
                                  exchangeRateEdit: e.floatValue,
                                })
                              }
                            }}
                            onBlur={props.handleBlur('exchange_rate')}
                            thousandSeparator={true}
                          />
                          {isErr[`exchangeRate_edit`] && (
                            <Section className="message">
                              {this.state.templateValidText}
                            </Section>
                          )}
                        </Table.TD>
                      </Table.TR>
                    </Table.TBODY>
                  </Table>
                </Section>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  className="theme-border-gray close"
                  onClick={() => {
                    this.toggleModal('editNewExchangeRate')
                    return document.body.classList.remove('modal-open')
                  }}
                >
                  Close
                </Button>

                <Button
                  className="theme-green save"
                  onClick={() => {
                    if (
                      this.validateExchangeRate(
                        'edit',
                        this.state.exchangeRateEdit
                      )
                    ) {
                      props.submitForm()
                      document.body.classList.remove('modal-open')
                    }
                  }}
                >
                  Ok
                </Button>
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    )
  }

  renderAddExchangeRate = () => {
    const { exchangeRateInsert, isErr, optionsCurrency } = this.state
    let optionsCurrencyList = []
    if (optionsCurrency && optionsCurrency.length) {
      optionsCurrency.map((item, i) => {
        if (item.value !== Number(this.state.companyForm.base_currency.id)) {
          optionsCurrencyList.push(item)
        }
      })
    }
    return (
      <>
        <Modal.Header>Add Exchange Rate</Modal.Header>
        <Modal.Body>
          {exchangeRateInsert.length > 0 && (
            <>
              <Section className="table-responsive">
                <Table className="table-fixed table-default is-scrollbar">
                  <Table.THEAD>
                    <Table.TR className="table-head-exchange-rate">
                      <Table.TH className="text-center">Country</Table.TH>

                      <Table.TH className="text-center">Currency</Table.TH>

                      <Table.TH className="text-center">Exchange Rate</Table.TH>

                      <Table.TH className="actions w-none text-center">
                        ACTION
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>
                  <Table.TBODY>
                    {exchangeRateInsert.map((item, index) => {
                      return (
                        <Table.TR key={index}>
                          <Table.TD className={`country`}>
                            <Input
                              name="country"
                              value={item.country}
                              onChange={event => {
                                item.country = event.target.value
                                if (this._isMounted) {
                                  this.setState({
                                    exchangeRateInsert,
                                  })
                                }
                              }}
                              disabled={true}
                            />
                          </Table.TD>
                          <Table.TD
                            className={`currency ${
                              isErr[`currency_${index}`] && 'is-error'
                            }`}
                          >
                            <SelectBox
                              className="is-currency"
                              id={`currency_exchange[${index}]`}
                              name={`currency_exchange[${index}]`}
                              value={item.currency}
                              options={optionsCurrencyList}
                              isSearchable={true}
                              menuPosition={'fixed'}
                              onChange={val => {
                                item.currency = val
                                item.currency_id = val.value
                                item.currency_name = val.label
                                item.country = val.country
                                isErr[`currency_${index}`] = ''
                                this.setState({
                                  exchangeRateInsert,
                                  isErr,
                                  isErrSelectIndex: index,
                                })
                              }}
                              isClearable={false}
                              isDisabled={false}
                            />
                            {isErr[`currency_${index}`] && (
                              <Section className="message">
                                {isErr[`currency_${index}`]}
                              </Section>
                            )}
                          </Table.TD>
                          <Table.TD
                            className={`exchange-rate text-right ${
                              isErr[`exchangeRate_${index}`] && 'is-error'
                            }`}
                          >
                            <NumberFormat
                              name={`exchange_rate[${index}]`}
                              value={item.exchange_rate}
                              customInput={Input}
                              decimalScale={4}
                              placeholder="0.0000"
                              isAllowed={inputObj => {
                                const { value } = inputObj
                                if (value !== '-') return true
                                return false
                              }}
                              onValueChange={e => {
                                if (e.floatValue <= 0) {
                                  item.exchange_rate = null
                                } else {
                                  item.exchange_rate = e.floatValue
                                }
                                isErr[`exchangeRate_${index}`] = ''
                                this.setState({
                                  exchangeRateInsert,
                                  isErr,
                                })
                              }}
                              thousandSeparator={true}
                              className="text-right"
                            />

                            {isErr[`exchangeRate_${index}`] && (
                              <Section className="message">
                                {isErr[`exchangeRate_${index}`]}
                              </Section>
                            )}
                          </Table.TD>
                          <Table.TD className="actions w-none text-center">
                            {exchangeRateInsert.length != 1 && (
                              <>
                                <Button
                                  className="icon"
                                  onClick={() => {
                                    exchangeRateInsert.splice(index, 1)
                                    isErr[`exchangeRate_${index}`] = ''
                                    isErr[`currency_${index}`] = ''
                                    if (this._isMounted) {
                                      return this.setState({
                                        isErr,
                                        exchangeRateInsert,
                                      })
                                    }
                                  }}
                                >
                                  <Image
                                    className="delete-icon"
                                    src={ICONS['icon-trash.svg']}
                                    alt="delete"
                                  />
                                </Button>
                              </>
                            )}
                          </Table.TD>
                        </Table.TR>
                      )
                    })}
                  </Table.TBODY>
                </Table>
              </Section>

              <Section className="form-actions-center">
                <Button
                  className="theme-blue"
                  onClick={() => {
                    if (this.validateExchangeRate('add')) {
                      let array = exchangeRateInsert.concat([
                        {
                          country: '',
                          currency: '',
                          currency_id: '',
                          currency_name: '',
                          exchange_rate: '',
                        },
                      ])
                      this.setState({ exchangeRateInsert: array })
                    }
                  }}
                >
                  Add more
                </Button>
              </Section>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="theme-border-gray close"
            onClick={() => {
              let { exchangeRateInsert } = this.state
              exchangeRateInsert = [
                {
                  country: '',
                  currency: '',
                  currency_id: '',
                  currency_name: '',
                  exchange_rate: '',
                },
              ]
              this.setState({ exchangeRateInsert, isErr: {} })
              this.toggleModal('addNewExchangeRate')
              document.body.classList.remove('modal-open')
            }}
          >
            Cancel
          </Button>

          <Button
            className="theme-green save"
            onClick={() => {
              if (this.validateExchangeRate('add')) {
                this.submitAddExchangeRate()
              }
            }}
          >
            Ok
          </Button>
        </Modal.Footer>
      </>
    )
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  render() {
    const {
      optionsCountry,
      optionsCurrency,
      isEditPageState,
      modals,
    } = this.state
    return (
      <React.Fragment>
        <CompanyProfileBuyerFormStyle>
          {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_buyer_management"
                  src={ICONS['icon-company-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  Company Profile
                </Section>
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          {/*renderDataCompany*/}
          {this.renderDataCompany(
            isEditPageState,
            optionsCountry,
            optionsCurrency
          )}
          {/* MODAL
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          <Modal
            className="theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'editSite'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth={'900px'}
          >
            {/*renderEditPurchasingSite*/}
            {this.renderEditPurchasingSite()}
          </Modal>

          {/*Modal Add New*/}
          <Modal
            id="add-new"
            className="purchasing-rate-modal theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'addNew'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth={'900px'}
          >
            {/*renderAddPurchasingSite*/}
            {this.renderAddPurchasingSite()}
          </Modal>

          {/*Modal Delete*/}
          <Modal
            id="delete"
            className="theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'delete'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth="575px"
          >
            <Modal.Header>Delete</Modal.Header>

            <Modal.Body>
              <p className="default text-center">
                Are you sure to delete? <br />
                {this.state.isDeletedName
                  ? this.state.isDeletedName
                  : this.state.isDeletedExchangeName}
              </p>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="close_modal_history_id"
                className="theme-border-gray"
                onClick={() => {
                  this.toggleModal('delete')
                  document.body.classList.remove('modal-open')
                  this.setState({
                    isDeletedName: '',
                    isDeletedExchangeName: '',
                  })
                }}
              >
                Cancel
              </Button>

              <Button
                id="close_modal_history_id"
                className="theme-green"
                onClick={() => {
                  if (this.state.isDeletedIndex.toString()) {
                    this.state.purchasingSite.splice(
                      this.state.isDeletedIndex,
                      1
                    )
                  } else {
                    this.state.exchangeRateList.splice(
                      this.state.isDeletedExchangeIndex,
                      1
                    )
                  }
                  if (this._isMounted) {
                    if (this.state.isDeletedIndex.toString()) {
                      this.setState({
                        purchasingSite: this.state.purchasingSite,
                        isDeletedIndex: '',
                        isDeletedName: '',
                        isDeletedExchangeName: '',
                      })
                    } else {
                      if (this.state.isDeletedExchangeId !== 0) {
                        this.state.isDeleteExchange.push({
                          currency_id: this.state.isDeletedCurrencyId,
                          id: this.state.isDeletedExchangeId,
                          is_delete: true,
                        })
                      }
                      this.setState({
                        exchangeRateList: this.state.exchangeRateList,
                        isDeleteExchange: this.state.isDeleteExchange,
                        isDeletedExchangeIndex: '',
                        isDeletedExchangeId: '',
                        isDeletedCurrencyId: '',
                        isDeletedName: '',
                        isDeletedExchangeName: '',
                        isDeletedIndex: '',
                      })
                    }
                  }
                  this.toggleModal('delete')
                  document.body.classList.remove('modal-open')
                }}
              >
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal Term & Condition */}
          <Modal
            id="terms-conditions"
            className="terms-conditions theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'terms-conditions'
                })
                .map(obj => obj.isOpen)[0]
            }
          >
            <Modal.Header>Terms & Conditions</Modal.Header>

            <Modal.Body>
              <Section className="terms-conditions-body">
                <Section>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.companyForm.term_condition,
                    }}
                  />
                </Section>

                <Section className="form-group">
                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper checkbox">
                      <Checkbox
                        id="supplier_need_to_join"
                        value="want-to-join"
                        checked={false}
                      >
                        I agree to the terms and conditions
                      </Checkbox>
                    </Section>
                  </Section>
                </Section>
              </Section>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="close_modal_add-supplier"
                className="theme-border-gray close"
                onClick={() => {
                  this.toggleModal('terms-conditions')
                  document.body.classList.remove('modal-open')
                }}
              >
                Cancel
              </Button>
              <Button
                className="theme-green save"
                onClick={() => {
                  this.toggleModal('terms-conditions')
                  document.body.classList.remove('modal-open')
                }}
              >
                Accept
              </Button>
            </Modal.Footer>
          </Modal>

          {/*Modal Add Exchange Rate*/}
          <Modal
            id="add-new-exchange"
            className="exchange-rate-modal theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'addNewExchangeRate'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth={'900px'}
          >
            {this.renderAddExchangeRate()}
          </Modal>

          {/* Edit Exchange Rate */}
          <Modal
            className="theme-blue"
            isOpen={
              modals
                .filter(modal => {
                  return modal.name === 'editNewExchangeRate'
                })
                .map(obj => obj.isOpen)[0]
            }
            modalWidth={'900px'}
          >
            {this.renderEditExchangeRate()}
          </Modal>
        </CompanyProfileBuyerFormStyle>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const CompanyProfileBuyerFormContainerComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyProfileBuyerFormContainer)

export default CompanyProfileBuyerFormContainerComponent
